// import { createBrowserRouter, Navigate, useLocation } from 'react-router-dom'
// import { PublicRoute, ProtectedRoute } from './PrivatePublicRoute'
// import {
//   ContactUs,
//   ForgotPassword,
//   HomePage,
//   Login,
//   SignUp,
//   VerifyCode,
//   SetPassWord,
//   Profilepage,
//   BrokerPage,
//   NewsPage,
//   NewsDetail,
//   AboutUs,
//   Components,
//   CurrentIpoPage,
//   UpcomingIpoPage,
//   ListedIpoPage,
//   BrokerDetail,
//   TermsAndConditionsPage,
//   PrivacyPolicyPage,
//   FAQsPage,
//   ApplyPage,
//   AppliedIpoList,
//   commonFunctions,
//   DeleteAccount,
//   PrivacyPolicyIpoTrend,
//   IPODashboardPage,
//   IPODetailsPage,
//   useSelector
// } from '../utils/npm'
// import { PATHS } from "../utils/utils"
// import ModifyAppliedIpo from '../pages/IPO/ModifyAppliedIpo'
// import IpoSubscriptionInner from '../components/ipoSubscriptionInner'
// import AppPrivacyPolicyPage from '../pages/CmsPage/AppPrivacyPolicyPage'
// import Android_AboutUs from '../pages/CmsPage/Android_AboutUs'
// import AndroidTermsAndConditions from '../pages/CmsPage/AndroidTermsAndConditions'
// import AndroidAppPrivacyPolicyPage from '../pages/CmsPage/AndroidAppPrivacyPolicyPage'
// import AndroidContactUs from '../pages/CmsPage/AndroidContactUs'
// import Loader from '../components/Loader'
// import { useEffect, useRef } from 'react'
// import OtpPage from '../pages/Auth/OtpPage'
// import SiteMapPage from '../pages/SiteMapPage'
// import DashboardLayout from './DashboardLayout'

import { createBrowserRouter, Navigate, useLocation } from 'react-router-dom';
import { lazy, Suspense, useEffect, useRef, useState } from 'react';
import { PublicRoute, ProtectedRoute } from './PrivatePublicRoute';
import { PATHS } from "../utils/utils";
import DashboardLayout from './DashboardLayout';
import Loader from '../components/Loader';
import { Components, useSelector } from '../utils/npm';
// import { CalanderPage } from '../pages/HomePage/CalanderPage';

export const Loadable = (Component) => (props) => {
  return (
    <Suspense >
      <Component {...props} />
    </Suspense>
  );
};

const ContactUs = Loadable(lazy(() => import('../pages/CmsPage/ContactUs')));
const ForgotPassword = Loadable(lazy(() => import('../pages/Auth/ForgotPassword')));
const HomePage = Loadable(lazy(() => import('../pages/HomePage/HomePage')));
const Login = Loadable(lazy(() => import('../pages/Auth/Login')));
const SignUp = Loadable(lazy(() => import('../pages/Auth/SignUp')));
const VerifyCode = Loadable(lazy(() => import('../pages/Auth/VerifyCode')));
const SetPassWord = Loadable(lazy(() => import('../pages/Auth/SetPassWord')));
const Profilepage = Loadable(lazy(() => import('../pages/Auth/ProfilePage')));
const BrokerPage = Loadable(lazy(() => import('../pages/Broker/BrokerPage')));
const NewsPage = Loadable(lazy(() => import('../pages/News/NewsPage')));
const NewsDetail = Loadable(lazy(() => import('../pages/News/NewsDetail')));
const AboutUs = Loadable(lazy(() => import('../pages/CmsPage/AboutUs')));
const CurrentIpoPage = Loadable(lazy(() => import('../pages/IPO/CurrentIpoPage')));
const UpcomingIpoPage = Loadable(lazy(() => import('../pages/IPO/UpcomingIpoPage')));
const ListedIpoPage = Loadable(lazy(() => import('../pages/IPO/ListedIpoPage')));
const BrokerDetail = Loadable(lazy(() => import('../pages/Broker/BrokerDetail')));
const TermsAndConditionsPage = Loadable(lazy(() => import('../pages/CmsPage/TermsAndConditions')));
const PrivacyPolicyPage = Loadable(lazy(() => import('../pages/CmsPage/PrivacyPolicyPage')));
const FAQsPage = Loadable(lazy(() => import('../pages/CmsPage/FAQs')));
const ApplyPage = Loadable(lazy(() => import('../pages/IPO/ApplyPage')));
const AppliedIpoList = Loadable(lazy(() => import('../pages/IPO/AppliedIpoList')));
const ModifyAppliedIpo = Loadable(lazy(() => import('../pages/IPO/ModifyAppliedIpo')));
const IpoSubscriptionInner = Loadable(lazy(() => import('../components/ipoSubscriptionInner')));
const DeleteAccount = Loadable(lazy(() => import('../pages/Auth/DeleteAccount')));
const PrivacyPolicyIpoTrend = Loadable(lazy(() => import('../pages/CmsPage/PrivacyPolicyIpoTrend')));
const IPODashboardPage = Loadable(lazy(() => import('../pages/HomePage/HomePage')));
const IPODetailsPage = Loadable(lazy(() => import('../pages/IPO/IPODetailsPage')));
const OtpPage = Loadable(lazy(() => import('../pages/Auth/OtpPage')));
const SiteMapPage = Loadable(lazy(() => import('../pages/SiteMapPage')));
const AppPrivacyPolicyPage = Loadable(lazy(() => import('../pages/CmsPage/AppPrivacyPolicyPage')));
const Android_AboutUs = Loadable(lazy(() => import('../pages/CmsPage/Android_AboutUs')));
const AndroidTermsAndConditions = Loadable(lazy(() => import('../pages/CmsPage/AndroidTermsAndConditions')));
const AndroidAppPrivacyPolicyPage = Loadable(lazy(() => import('../pages/CmsPage/AndroidAppPrivacyPolicyPage')));
const AndroidContactUs = Loadable(lazy(() => import('../pages/CmsPage/AndroidContactUs')));
const OpenAppRedirect = Loadable(lazy(() => import('../pages/HomePage/OpenAppRedirect')));
// const path = require('path');

const { IpoDetail, Header, Footer } = Components

export const Layout = ({ children }) => {
  const isloading = useSelector((state) => state.masterSlice.isloading);
  const layoutRef = useRef(null);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  let scrolltoTopRef = useRef();
  const scrollView = () => {
    if (scrolltoTopRef.current) {
      scrolltoTopRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {

  }, [])


  useEffect(() => {
    scrollView()
  }, [children]);

  useEffect(() => {
    setIsLoading(false)
  }, [])

  return (
    <>
      <div ref={scrolltoTopRef}>
        <Header />
        {isloading ? (<>
          <div className="flex justify-center items-center custom-min-height">
            <Loader />
          </div>
          <div className="container ">
            <div className="border rounded-xl ">
              <div className="flex justify-center item-center custom-min-height">
                <Loader />
              </div>
            </div>
          </div>
          {/* // <div className='fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
          //   <Loader />
          // </div> */}
        </>) : (
          children
        )}
        {!isLoading && <Footer />}
      </div>
    </>
  );
};


// const Layout = ({ children }) => {
//   const isloading = useSelector((state) => state.masterSlice.isloading);
//   const scrolltoTopRef = useRef();

//   const scrollView = () => {
//     if (scrolltoTopRef.current) {
//       scrolltoTopRef.current.scrollIntoView({ behavior: 'smooth' });
//     }
//   };

//   useEffect(() => {
//     scrollView();
//   }, [children]);

//   return (
//     <>
//       <div ref={scrolltoTopRef}>
//         <Header />
//         {isloading ? (
//           <div className="flex justify-center items-center custom-min-height">
//             <Loader />
//           </div>
//         ) : (
//           children
//         )}
//         <Footer />
//       </div>
//     </>
//   );
// };

const wrapRouteold = (route, wrapper) => {

  // document.addEventListener('contextmenu', (e) => {
  //   e.preventDefault(); // Disable right-click
  // });

  // document.addEventListener('keydown', function (e) {
  //   // Disable F12, Ctrl+Shift+I, and Ctrl+U
  //   if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I') || (e.ctrlKey && e.key === 'U')) {
  //     e.preventDefault();
  //   }
  // });

  // function generateSitemap() {
  //   const sitemap = new Sitemap(route)
  //     .build('https://yourwebsite.com') // Your website's base URL
  //     .save(path.resolve(__dirname, 'public/sitemap.xml')); // Location to save the sitemap file
  // }

  if (wrapper === 'public') {
    return {
      ...route,
      element: <PublicRoute>{route.element}</PublicRoute>,
    };
  } else if (wrapper === 'protected') {
    return {
      ...route,
      element: <ProtectedRoute>{route.element}</ProtectedRoute>,
    };
  } else if (wrapper === 'withoutHeaderFooter') {
    return {
      ...route,
      element: route.element,
    };
  }
  return {
    ...route,
    element: <Layout>{route.element}</Layout>,
  };
};


// const wrapRouteold = (route, wrapper) => {
//   if (wrapper === 'public') {
//     return {
//       ...route,
//       element: <PublicRoute>{route.element}</PublicRoute>,
//     };
//   } else if (wrapper === 'protected') {
//     return {
//       ...route,
//       element: <ProtectedRoute>{route.element}</ProtectedRoute>,
//     };
//   } else if (wrapper === 'withoutHeaderFooter') {
//     return {
//       ...route,
//       element: route.element, // No Header/Footer
//     };
//   }
//   return {
//     ...route,
//     element: <Layout>{route.element}</Layout>,
//   };
// };

const routes = [
  // Public Routes
  { path: PATHS.LOGIN, element: <Login /> },
  { path: PATHS.SIGNUP, element: <SignUp /> },
  { path: PATHS.OTPPAGE, element: <OtpPage /> },

  // Protected Routes
  { path: PATHS.PROFILE, element: <Profilepage />, wrapper: 'protected' },
  { path: PATHS.APPLIED_IPO, element: <AppliedIpoList />, wrapper: 'protected' },
  { path: PATHS.APPLY, element: <ApplyPage />, wrapper: 'protected' },
  { path: PATHS.MODIFY, element: <ModifyAppliedIpo />, wrapper: 'protected' },

  { path: PATHS.HOME, element: <HomePage /> },
  { path: PATHS.IPODASHBOARD, element: <IPODashboardPage /> },

  { path: PATHS.IPODETAILS, element: <IPODetailsPage /> },
  { path: PATHS.IPODETAILS_NAME, element: <IPODetailsPage /> },

  { path: PATHS.IPO_DETAIL, element: <IpoSubscriptionInner /> },
  { path: PATHS.IPO_DETAIL_ID, element: <IpoSubscriptionInner /> },

  { path: PATHS.FORGOT_PASSWORD, element: <ForgotPassword /> },
  { path: PATHS.VERIFY_CODE, element: <VerifyCode /> },
  { path: PATHS.SET_NEW_PASSWORD, element: <SetPassWord /> },
  { path: PATHS.SET_NEW_PASSWORD, element: <SetPassWord /> },
  { path: PATHS.BROKER, element: <BrokerPage /> },
  { path: PATHS.NEWS, element: <NewsPage /> },
  { path: PATHS.ABOUT_US, element: <AboutUs /> },
  { path: PATHS.LIVE, element: <CurrentIpoPage /> },
  { path: PATHS.UPCOMING, element: <UpcomingIpoPage /> },
  { path: PATHS.LISTED, element: <ListedIpoPage /> },

  { path: PATHS.APP_PRIVACY_POLICY, element: <AppPrivacyPolicyPage /> },

  { path: PATHS.ABOUT_US, element: <AboutUs /> },
  { path: PATHS.TERMS_AND_CONDITIONS, element: <TermsAndConditionsPage /> },
  { path: PATHS.PRIVACY_POLICY, element: <PrivacyPolicyPage /> },
  { path: PATHS.CONTACT_US, element: <ContactUs /> },

  { path: PATHS.ANDROID_ABOUT_US, element: <Android_AboutUs />, wrapper: 'withoutHeaderFooter' },
  { path: PATHS.ANDROID_TERMS_AND_CONDITIONS, element: <AndroidTermsAndConditions />, wrapper: 'withoutHeaderFooter' },
  { path: PATHS.ANDROID_PRIVACY_POLICY, element: <AndroidAppPrivacyPolicyPage />, wrapper: 'withoutHeaderFooter' },
  { path: PATHS.ANDROID_CONTACT_US, element: <AndroidContactUs />, wrapper: 'withoutHeaderFooter' },
  { path: PATHS.DELETEACCOUNT, element: <DeleteAccount />, wrapper: 'withoutHeaderFooter' },

  { path: PATHS.MARKET_NEWS_DETAIL, element: <NewsDetail /> },
  { path: PATHS.MARKET_NEWS_DETAIL_NAME, element: <NewsDetail /> },

  { path: PATHS.BROKER_DETAIL, element: <BrokerDetail /> },
  { path: PATHS.PRIVACY2, element: <PrivacyPolicyIpoTrend /> },
  { path: PATHS.FAQS, element: <FAQsPage /> },
  { path: PATHS.IPOSUBINNER, element: <IpoSubscriptionInner /> },

  { path: PATHS.GOOGLE_SITE_MAP, element: <SiteMapPage /> },
  { path: PATHS.OPEN_APP, element: <OpenAppRedirect /> },

  { path: PATHS.NOT_FOUND, element: <Navigate to={PATHS.HOME} /> },
];

const wrapRoute = (route) => {

  if (route.wrapper === "public") {
    return {
      ...route,
      element: <PublicRoute>{route.element}</PublicRoute>,
    };
  }

  if (route.wrapper === "protected") {
    return {
      ...route,
      element: <ProtectedRoute>{route.element}</ProtectedRoute>,
    };
  }

  return route;
};

const wrappedRoutes = routes.map((route) =>
  wrapRouteold(route, route.wrapper),
);

// Create Router

export const RouterLinks = createBrowserRouter(wrappedRoutes, {
  future: {
    v7_fetcherPersist: true,
    v7_startTransition: true,
    v7_relativeSplatPath: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_skipActionErrorRevalidation: true,
  },
});

// console.log('RouterLinks', RouterLinks);

// export const RouterLinks = createBrowserRouter([
//   {
//     path: "/",
//     element: <DashboardLayout />, // Layout with Header & Footer
//     children: wrappedRoutes, // All routes rendered inside <Outlet />
//   },
// ], {
//   future: {
//     v7_fetcherPersist: true,
//     v7_startTransition: true,
//     v7_relativeSplatPath: true,
//     v7_normalizeFormMethod: true,
//     v7_partialHydration: true,
//     v7_skipActionErrorRevalidation: true,
//   },
// });;
